(() => {
  'use strict';
  const query = new URLSearchParams(window.location.search);
  const reduce = window.matchMedia('(prefers-reduced-motion: reduce)');
  const fine = window.matchMedia('(hover: hover) and (pointer: fine)');
  let panel = null;
  function replay() {
    document.dispatchEvent(new CustomEvent('buton:replay-intro'));
  }
  function diagnosticData() {
    const hero = document.querySelector('.v13-hero');
    const beam = hero?.querySelector('.v13-hero__beam');
    let seen = false;
    try { seen = sessionStorage.getItem('buton-v13-motionfix-welcomed') === '1'; } catch (error) {}
    return [
      ['Theme section', hero ? 'Grand Entrance found' : 'Not on the homepage'],
      ['Shopify editor', document.body.dataset.v13Editor === 'true' ? 'YES - automatic intro intentionally paused' : 'No - external preview'],
      ['Intro setting', document.body.dataset.v13IntroEnabled === 'true' ? 'Enabled' : 'Disabled'],
      ['Intro seen this session', seen ? 'YES - add buton_intro=1 to replay' : 'No'],
      ['Reduced motion', reduce.matches ? 'ON - normal motion is intentionally restricted' : 'Off'],
      ['Motion override', document.documentElement.classList.contains('v13-force-motion') ? 'Opted in for this preview' : 'Respect device preference'],
      ['Desktop pointer', fine.matches ? 'Fine pointer detected' : 'Touch/emulation or non-hover pointer'],
      ['Desktop blue light', document.body.dataset.v12Light === 'false' ? 'Disabled in theme settings' : 'Enabled'],
      ['Interactive stage', hero?.dataset.v13Wired === 'true' ? 'JavaScript connected' : 'Not connected / section missing'],
      ['Motion script', 'Loaded - diagnostic active'],
      ['CSS light animation', beam ? getComputedStyle(beam).animationName : 'No stage'],
      ['Viewport', `${window.innerWidth} x ${window.innerHeight}`]
    ];
  }
  function showDiagnostic() {
    if (!panel) {
      panel = document.createElement('section');
      panel.className = 'v13-debug-panel';
      panel.setAttribute('role','region');
      panel.setAttribute('aria-label','BÛTÓN preview diagnostics');
      document.body.append(panel);
    }
    const rows = diagnosticData();
    panel.replaceChildren();
    const h = document.createElement('h2');
    h.textContent = 'BÛTÓN / EFFECTS CHECK';
    panel.append(h);
    const table = document.createElement('dl');
    for (const [k,v] of rows) {
      const dt = document.createElement('dt');
      const dd = document.createElement('dd');
      dt.textContent = k;
      dd.textContent = v;
      table.append(dt,dd);
    }
    panel.append(table);
    const controls = document.createElement('div');
    controls.className = 'v13-debug-panel__actions';
    const replayBtn = document.createElement('button');
    replayBtn.type = 'button';
    replayBtn.textContent = 'REPLAY INTRO';
    replayBtn.addEventListener('click', replay);
    const enable = document.createElement('button');
    enable.type = 'button';
    enable.textContent = document.documentElement.classList.contains('v13-force-motion') ? 'RESPECT DEVICE MOTION' : 'TRY FULL MOTION';
    enable.addEventListener('click', () => {
      document.documentElement.classList.toggle('v13-force-motion');
      document.dispatchEvent(new CustomEvent('buton:motion-change'));
      showDiagnostic();
    });
    const refresh = document.createElement('button');
    refresh.type = 'button';
    refresh.textContent = 'REFRESH CHECK';
    refresh.addEventListener('click', showDiagnostic);
    const close = document.createElement('button');
    close.type = 'button';
    close.textContent = 'CLOSE';
    close.addEventListener('click', () => { panel.remove(); panel = null; });
    controls.append(replayBtn,enable,refresh,close);
    panel.append(controls);
  }
  function init() {
    document.querySelectorAll('[data-v13-preview-replay]').forEach(button => {
      if (button.dataset.connected) return;
      button.dataset.connected = 'true';
      button.addEventListener('click', replay);
    });
    document.querySelectorAll('[data-v13-preview-effects]').forEach(button => {
      if (button.dataset.connected) return;
      button.dataset.connected = 'true';
      button.addEventListener('click', showDiagnostic);
    });
    if (query.get('buton_debug') === '1') showDiagnostic();
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, {once:true});
  } else init();
  document.addEventListener('shopify:section:load', init);
})();
